/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from "react";
import {Calendar} from "primereact/calendar";
import moment from "moment";
import './ButtonIcon.css';


const FieldTime = ({colMd, colSm, label, name, onChange, onBlur, error, errors, disabled, value, className, showButtonBar, required}) => {

    const [selectedValue, setSelectedValue] = useState(null);

    function onValueChange(event) {

        if (onChange == null)
            return;

        const newValue = event.value == null ? null : moment(event.value).format('HH:mm');
        onChange(newValue, name);
    }

    useEffect(() => {
        if (value !==  moment(selectedValue).format('HH:mm')){
                const newValue = value==null? value : moment(value, 'HH:mm').toDate()
                console.log(newValue)
                setSelectedValue(newValue);
        }
    }, [value]);

    const handleTodayClick = () => {
        const newValue = moment().format('HH:mm');
        setTimeout(() => {
            onChange(newValue, name);
        }, 100);

    };


    return (
        <>
            {label &&
            <div className={`form-group col-md-${colMd} col-sm-${colSm != null ? colSm : '12'}`}>
                {required ? '*':''}<label htmlFor={name}>{label}</label>
                <Calendar id={name}
                          value={selectedValue}                         
                          timeOnly 
                          hourFormat="24"
                          mask={'99:99'}
                          showIcon
                          className={`prime-form-control ${className??''} ${ (error || errors?.[name]) ? 'error' : ''}`}
                          onChange={onValueChange}
                          showButtonBar ={showButtonBar??true}
                          disabled={disabled }
                          onInput={(e)=>console.log(e)}
                          onBlur={onBlur}/>
            </div>
            }
            {!label &&
            <Calendar id={name}
                      value={selectedValue}
                      timeOnly 
                      hourFormat="24"
                      mask={'99:99'}
                      showButtonBar ={showButtonBar??true}
                      showIcon
                      onInput={(e)=>console.log(e)}
                      className={`prime-form-control ${className??''} ${ (error || errors?.[name]) ? 'error' : ''}`}
                      onChange={onValueChange}
                      disabled={disabled }
                      onTodayButtonClick={handleTodayClick}

                      onBlur={onBlur}/>
            }
        </>
    )
};

export default FieldTime;